module.exports = __webpack_public_path__ + "static/media/Barmag 4b1.2d08bec3.jpg";